import {Component, Input, OnInit} from '@angular/core';
import {Change} from '@wba/store/models/changelog.state';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {selectChangelogForTypeAndVersion} from '@wba/store/reducers/changelog.reducers';
import {EinkommenSchluesselEnum} from '@wba/models/enums/einkommen-typ.enum';
import {mergeMap} from 'rxjs/operators';

@Component({
    selector: 'wba-changelog-box',
    templateUrl: './changelog-box.component.html',
    standalone: false
})
export class ChangelogBoxComponent implements OnInit {
  @Input() type: EinkommenSchluesselEnum;
  @Input() formVersionSaved$: Observable<number>;

  changelog$: Observable<Change[]>;

  constructor(private readonly store: Store) {
  }

  ngOnInit() {
    this.changelog$ = this.formVersionSaved$.pipe(
      mergeMap((formVersionSaved) => {
        const filterProps = {type: this.type, formVersionSaved};
        return this.store.select(selectChangelogForTypeAndVersion, filterProps);
      }),
    );
  }

  getLabelFor({inputId, label}: Change): string {
    if (label) {
      // Some inputs may not be rendered due to the dynamic displaying,
      // or simply don't have a title.
      // A fallback-label for those inputs is necessary.
      return label;
    }

    const el = document.getElementById(inputId);
    if (el?.title) {
      return el.title;
    }

    console.error(`[changelog] Element not found and no title set.
           > Check id or add a label for: ${inputId} \n\n`);
    return 'unknown element';
  }

  jumpTo($event, id) {
    $event.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({inline: 'center', block: 'center', behavior: 'smooth'});
      element.focus({preventScroll: true});
    }
  }
}
